/*
 * Copyright © 2020 by Pactera Technology Japan Co., Ltd.
 *
 * Code written by Atilika Inc. Contact us at hello@atilika.com.
 */

import { JsonAny } from "../../Types";
import { Tag } from "./VideoFilter";

export type ThemeTag = "SAP" | "社内システム" | "プロジェクト管理" | "予算管理" | "人材育成";
export const THEME_TAGS: ThemeTag[] = ["SAP", "社内システム", "プロジェクト管理", "予算管理", "人材育成"];

export type PresentationTypeTag = "講演会" | "勉強会" | "打ち合わせ";
export const PRESENTATION_TYPE_TAGS: PresentationTypeTag[] = ["講演会", "勉強会", "打ち合わせ"];

export type InternalExternalTag = "社内" | "社外";
export const INTERNAL_EXTERNAL_TAGS: InternalExternalTag[] = ["社内", "社外"];

export type TargetGroupTag = "管理職" | "PM" | "ジュニア";
export const TARGET_GROUP_TAGS: TargetGroupTag[] = ["管理職", "PM", "ジュニア"];

export type VideoTag = ThemeTag | PresentationTypeTag | InternalExternalTag | TargetGroupTag;

export const VIDEO_TAG_TYPES = [
    ...THEME_TAGS,
    ...PRESENTATION_TYPE_TAGS,
    ...INTERNAL_EXTERNAL_TAGS,
    ...TARGET_GROUP_TAGS
];

export function parseTag(json: JsonAny): Tag {
    return {
        tag: json,
        tagCount: 0
    };
}